import { Component, ElementRef, Injector, ViewChild, AfterContentInit, AfterViewInit } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as jQuery from "jquery";
import { IChartTechnicalIndicatorInfo } from "../../achart/achart.technicalIndicators";
import { initRequest, DataService } from "../../../services/data/data.service";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { BoxQuotaData} from "../../../model/box.quote.data";
import { validateConfig } from "@angular/router/src/config";
import { IQuotaData, getPipBySymbol, numberToFixedPrecision } from "../../../interfaces/quote.data";
import { TradeRequestModel, EditRq, PartialCloseRq } from "../../../model/trade.request.data";
import { CookiesService } from "../../../tools/cookies.service";
import { IOrdersData } from "../../../interfaces/service.response";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { SymbolTypeEnum } from "../../../enums/SymbolType.enum";
import { map } from "rxjs/operators";
import { ShowOrderConfirmationModal } from "../orderconfirmation/show-order-confirmation-modal";
import { Account } from '../../../api/DixApiClient';
import {Providers} from "../../../enums/providers";

@Component({
    selector: "modal-orderentry",
    template: require('./orderentry.component.html'),
    styles: [require('./orderentry.component.css')]
})
export class OrderEntryModal implements  AfterViewInit {

    ngAfterViewInit(): void {
        this.placeOrderButton && (this.placeOrderButton.nativeElement.onclick = this.placeOrder.bind(this));
      
    }

    @ViewChild("Quantity")
    inputQty: any = null;

    @ViewChild("placeOrderButton")
    placeOrderButton!: ElementRef;

    editMode = false;
    editedOrder?: IOrdersData;

    symbols: string[] | undefined;
    private _isOpenFromScanner: boolean = false;
    public get isOpenFromScanner (): boolean {
        return this._isOpenFromScanner;
    }
    public set isOpenFromScanner ( value: boolean ) {
        this._isOpenFromScanner = value;

        if(value)
        {
            let mapActiveSymbols =  this.workspaceService.data.scanResultList.map(b => b.symbol);


            this.activeSymbols = mapActiveSymbols;

        }




    }
    private _activeSymbols: string[] | undefined;
    public get activeSymbols (): string[] | undefined {

        if(this.isOpenFromScanner)
        {
            return this.workspaceService.data.scanResultList.map(b => b.symbol);
        }
        return this._activeSymbols;
    }
    public set activeSymbols ( value: string[] | undefined ) {


            if(!this.isOpenFromScanner)
            {

        
            let mapActiveSymbols =  this.workspaceService.data.boxes.filter(c => {
                    return this.workspaceService.data.activeSymbolType == c.Type;
                }).map(b => b.Symbol);

                if(value)
                {

                this._activeSymbols = value.filter(z=>{
                    return mapActiveSymbols.indexOf(z)>-1;
                }); 
            }
            else
            {
                this._activeSymbols = value
            }

    }
    }

    typesEnum = OrderEntryType;
    types: any[] | undefined;
    operationTypesEnum = OrderOperationType;
    operationTypes: any[] | undefined;
    timeExpiry: NgbDateStruct | any;
    dateExpiry: NgbDateStruct | undefined;

    public selectedSymbol: any = "";

    protected _stopValue: number = 0;
    protected _stopPip: number = 25;
    protected _pipValue: number = 0;
    protected _marginRequired: number = 0;

    protected _limitValue: number = 0;
    protected _limitPip: number = 25;
    protected _leverage: number = 33.33;
    protected _rateDisabled: boolean = true;
    public get item(): BoxQuotaData {
        return this.getSymbolItem(this.symbol);
    }



    //private _leverage: number = 3.33;
    public get leverage (): number {

        if(this.workspaceService.data.currentProvider==Providers.OANDA && this.oandaLeverage)
        {
            return 100*this.oandaLeverage;
        }

        return this.item.MarginPerc;
    }
   

    private _oandaLeverage: number | undefined;
    public get oandaLeverage(): number | undefined {
        return this._oandaLeverage;
    }
    public set oandaLeverage(value: number | undefined) {
        this._oandaLeverage = value;
    }






    getSymbolItem(symbol: string) {
        return (
            this.workspaceService.data.boxes.filter(x => x.Symbol == this.symbol)[0] ||
            this.workspaceService.data.boxes[0] ||
            new BoxQuotaData(this.workspaceService.data)
        );
    }

    defaultQSizeList: IqSizeData[] = [
        { label: "1", value: 1 },
        { label: "10", value: 10 },
        { label: "100", value: 100 },
        { label: "1000", value: 1000 },
        { label: "10000", value: 10000 },
        { label: "100000", value: 100000 }
    ];

    defaultFixMetalsQSizeList: IqSizeData[] = [
        { label: "1 oz", value: 1 },
        { label: "10 oz", value: 10 },
        { label: "100 oz", value: 100 },
        { label: "1000 oz", value: 1000 },
    ];

    defaultFixMetalsAgQSizeList: IqSizeData[] = [
        { label: "5 oz", value: 5 },
        { label: "10 oz", value: 10 },
        { label: "100 oz", value: 100 },
        { label: "1000 oz", value: 1000 },
    ];

    defaultQtiesList: IqSizeData[] = [
        { label: "1", value: 1 },
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "5", value: 5 },
        { label: "6", value: 6 },
        { label: "7", value: 7 },
        { label: "8", value: 8 },
        { label: "9", value: 9 },
        { label: "10", value: 10 }
    ];
    forexQtiesList: IqSizeData[] = [
        { label: "1", value: 1 },
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "5", value: 5 },
        { label: "[+]Enter", value: -1 }
    ];
    windowData: IDataBySymbolType = {
        forex: {
            SideLabel: "Side",
            //MarginInfoLabel: "*Estimated Price",
            MarginInfoLabel: "*Margin Required",
            //RateLabel: "Currency",
            RateLabel: "Rate",
            SymbolTypeLabel: "Forex",
            showSideDropDown: true,
            currencyFormatter: false,
            rawQtyShow: false,
            defaultQty: 10000,
            qQtiesList: this.forexQtiesList,
            qSizesList: [
                { label: "1k (Micro)", value: 1000 },
                { label: "10K (Mini)", value: 10000 },
                { label: "100k (Std)", value: 100000 }
            ]
        },
        crypto: {
            SideLabel: "Action",
            //MarginInfoLabel: "*Estimated Total",
            MarginInfoLabel: "*Margin Required",
          //  RateLabel: "Currency",
            RateLabel: "Rate",
            SymbolTypeLabel: "Crypto",
            showSideDropDown: false,
            currencyFormatter: true,
            rawQtyShow: true,
            defaultQty: 30,
            qQtiesList: this.defaultQtiesList,
            qSizesList: this.defaultQSizeList
        },
        equity: {
            SideLabel: "Action",
          //  MarginInfoLabel: "*Estimated Total",
            MarginInfoLabel: "*Margin Required",
         //   RateLabel: "Price",
            RateLabel: "Rate",
            SymbolTypeLabel: "Equity",
            showSideDropDown: false,
            currencyFormatter: true,
            rawQtyShow: true,
            defaultQty: 30,
            qQtiesList: this.defaultQtiesList,
            qSizesList: this.defaultQSizeList
        },
        commodity: {
            SideLabel: "Side",
            MarginInfoLabel: "*Margin Required",
          //  MarginInfoLabel: "*Estimated Total",
           // RateLabel: "Price",
            RateLabel: "Rate",
            SymbolTypeLabel: "Commodity",
            showSideDropDown: true,
            currencyFormatter: true,
            rawQtyShow: false,
            defaultQty: 10000,
            qQtiesList: this.defaultQtiesList,
            qSizesList: this.defaultQSizeList
        },
        index: {
            SideLabel: "Side",
            //MarginInfoLabel: "*Estimated Total",
            MarginInfoLabel: "*Margin Required",
         //   RateLabel: "Price",
            RateLabel: "Rate",
            SymbolTypeLabel: "Index",
            showSideDropDown: true,
            currencyFormatter: false,
            rawQtyShow: false,
            defaultQty: 10000,
            qQtiesList: this.defaultQtiesList,
            qSizesList: this.defaultQSizeList
        },
        bonds: {
            SideLabel: "Action",
            //MarginInfoLabel: "*Estimated Total",
            MarginInfoLabel: "*Margin Required",
       //     RateLabel: "Price",
            RateLabel: "Rate",
            SymbolTypeLabel: "Bonds",
            showSideDropDown: false,
            currencyFormatter: true,
            rawQtyShow: true,
            defaultQty: 30,
            qQtiesList: this.defaultQtiesList,
            qSizesList: this.defaultQSizeList
        }
    };

    entryData: IOrderEntryData = {
        type: OrderEntryType.Market,
        symbol: "",
        entryPrice: 0,
        quantity: 1,
        expires: false,
        operationType: OrderOperationType.Buy
    };

    protected _type: OrderEntryType = OrderEntryType.Market;
    protected onlyForexSymbols:string[] = [];

    

    constructor(
        public activeModal: NgbActiveModal,
        protected element: ElementRef,
        protected dataService: DataService,
        protected modalService: NgbModal,
        protected cookieService: CookiesService,
        protected workspaceService: WorkspaceServiceService,
        protected workspaceServiceService: WorkspaceServiceService
    ) {
        let noIndexSymbols = this.workspaceService.data.boxes.filter(c => {
            if (c.Type != SymbolTypeEnum.Index) {
                return c;
            }
        });
        
        this.symbols = noIndexSymbols.map(b => b.Symbol);
        this.activeSymbols = this.symbols;

        if(this.workspaceService.data.tournamentUserSelected || this.workspaceService.data.currentProvider!=Providers.DEMO)
        {
            this.onlyForexSymbols = this.workspaceService.data.boxes.filter(c => {

                if(this.workspaceService.data.currentProvider==Providers.DEMO)
                {
                    if (this.workspaceService.data.availableAssetsForUser!.indexOf(c.Type)>-1) {
                        return c;
                    }
                }
                else{
                    return c
                }

            }).filter(l=>{

                if(this.workspaceService.data.competitionAccountList.indexOf(this.workspaceService.data.activeAccountIdBySet)>-1 || this.workspaceService.data.currentProvider!=Providers.DEMO)
                {
                // //console.log(this.workspace.currentTournaments[0].tournamentAssets);
                    if(this.workspaceService.data.allowedForexSymbols.indexOf(l.Symbol)>-1)//&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                    {
                        return true;
                    }
                    else
                    {
                        return false;
                    }
                }
                else
                {
                    return true;
                };
            }
            ).map(b => b.Symbol);


            this.activeSymbols =  this.onlyForexSymbols;
        }


        // //console.log(noIndexSymbols);

      


       


        this.entryData.type = this.type;

        this.entryData.entryPrice = this.entryPrice;
        // this.entryData.expires = this.expires;
        //  this.entryData.expiryDate = this.expiryDate;
        this.entryData.quantity = this.quantity;
        this.entryData.symbol = this.symbol;

        this.entryData.operationType = this.operationType;

        this.types = Object.keys(this.typesEnum).filter(f => !isNaN(Number(f)));
        this.operationTypes = Object.keys(this.operationTypesEnum).filter(f => !isNaN(Number(f)));
       
        //console.log("this.workspaceService.data.lastTradeInformations");

        
        this.selectedTradingAccountId = this.activeAccountId;

        this.updatePriceByOperationType();
    }

    public get AccountName()
    {
       
        return this.getFullAccountNameById(this.selectedTradingAccountId);
    }

    public get showAccountSelect()
    {
        return false;
    }

    public factor: number = 1;
    updateMarginRequiredAndPip() {
        console.log(this.symbol);
        let base = this.symbol.split("/")[1];

        if (base == "USD") {
            this.factor = 1;
        } else {
            this.factor = this.getUsdValue(base);
        }

        this.pipValue = this.factor * this.quantity * this.item.Pip;
        console.log([this.factor, this.quantity, this.item.Pip, this.pipValue])
        this.pipValue = Number(this.pipValue.toFixed(2));
        //  (cad/usd)(usd/cad)

        let marginRequiredTemp =  this.quantity*this.factor*this.item.Ask*this.leverage/100;
            // (this.factor * Math.pow(10, this.item.Decimal - 1) * (this.item.Ask * this.quantity * this.item.Pip)) /
            // this.leverage;
        this.marginRequired = Number(marginRequiredTemp.toFixed(2));
    }

    public get AllowPendingOrders()
    {
        return this.workspaceService.data.allowPendingOrders;
    }


    protected getUsdValue(t: string): number {


        if(this.workspaceService.data.currentAccountCurrencyCode == "USD")
        {

       
            if (
                this.dataService.lastQuotes[t + "/USD"] === undefined &&
                this.dataService.lastQuotes["USD/" + t] === undefined
            ) {
                return 1;
            }

            if (this.dataService.lastQuotes[t + "/USD"] === undefined) {
                return 1 / this.dataService.lastQuotes["USD/" + t].A;
            } else {
                return this.dataService.lastQuotes[t + "/USD"].A;
            }

        }
        else
        {
           let str = "/"+this.workspaceService.data.currentAccountCurrencyCode;
           let strReverse = this.workspaceService.data.currentAccountCurrencyCode+"/";
            if (
                this.dataService.lastQuotes[t + str] === undefined &&
                this.dataService.lastQuotes[strReverse + t] === undefined
            ) {
                return 1;
            }

            if (this.dataService.lastQuotes[t + str] === undefined) {
                return 1 / this.dataService.lastQuotes[strReverse + t].A;
            } else {
                return this.dataService.lastQuotes[t + str].A;
            }
        }


    }

    getCurrentQuoteValue() {}
    public orderID: number = 0;

    protected _editableRate: boolean = false;
    public get editableRate(): boolean {
        return this._editableRate;
    }
    public set editableRate(value: boolean) {
        this._editableRate = value;
    }

    protected _rawQtyShow: boolean = false;
    public get rawQtyShow(): boolean {
        return this._rawQtyShow;
    }
    public set rawQtyShow(value: boolean) {
        this._rawQtyShow = value;
    }

    editOrder(order: IOrdersData) {

        if(this.AllowPendingOrders)
        {
            this.pipsFactor = -1;
        }

        order.Stop = parseFloat(order.EditRq.StopPrice as any);
        order.Limit = parseFloat(order.EditRq.LimitPrice as any);

        //console.log(order.EditRq);

        this.editMode = true;

        this.editedOrder = order;
        this.operationType = order.EditRq.Side.toLowerCase().includes("buy")
            ? OrderOperationType.Buy
            : OrderOperationType.Sell;
        this.type = order.EditRq.Type.toLowerCase().includes("pending")
            ? OrderEntryType.Pending
            : OrderEntryType.Market;

        this.editableRate = this.type == OrderEntryType.Pending ? true : false;

        this.symbol = order.EditRq.Currency;
        this.quantity = order.EditRq.Quantity;

        let currentItem = this.workspaceService.data.boxes.filter(c => {
            if (c.Symbol == this.symbol) {
                return c;
            }
        });

        if(this.type==OrderEntryType.Pending && this.workspaceService.data.allowPendingOrders)
        {
            this.entryPrice = order.EntryPrice;
           
        }
        else
        {
             this.entryPrice = currentItem[0].Ask;
        }
       

        let qtyFactor: number = this.quantity < 0 ? -1 : 1;

        let mapqSize: number[] = this.qSizeListData.map(c => {
            return c.value;
        });
        let mapqQties: number[] = this.qQtiesListData.map(c => {
            return c.value;
        });

        let qtyTarget: number[] = crossMultiplyArrayValFinder(mapqSize, mapqQties, Math.abs(this.quantity));

        //console.log(qtyTarget);

        if (qtyTarget.length > 0) {
            this.qSize = mapqSize[qtyTarget[0]];
            this.qQty = mapqQties[qtyTarget[1]];
        } else {
            this.rawQtyShow = true;
        }

        this.quantity = qtyFactor * this.quantity;

        this.equityQtyInputMode = true;

        this.orderID = order.EditRq.Id;

        if (!isNaN(order.EditRq.StopPrice)) {
            this.stopValue = order.EditRq.StopPrice;

            this.stopch = this.stopValue != 0 ? true : false;
            
         //      if(order.EditRq.StopPips!=0)
        //       this.stopPip = order.EditRq.StopPips;
            if(this.stopch)
            {
                this.StopManualMode = true;
                this.hideTrailingStop = true;
                this.updateStopPips();
            }
           
        }

        if (!isNaN(order.EditRq.LimitPrice)) {
            this.limitValue = order.EditRq.LimitPrice;
            this.limitch = this.limitValue != 0 ? true : false;

         //    if(order.EditRq.LimitPips!=0)
        //    this.limitPip = order.EditRq.LimitPips;

            if(this.limitch)
            {
                this.LimitManualMode = true; 
                this.updateLimitPips();
            }
           
        }

        if(order.Trailing>0)
        {
            this.trailingstopch = true;
            this.trailingStopPip = order.Trailing;
            this.hideStop = true;
        }


        if(this.operationType == OrderOperationType.Buy)
        {
            this.stopValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.stopPip;
            this.limitValue = this.entryPrice - this.pipsFactor * this.item.Pip * this.limitPip;
        }
        else
        {
            this.stopValue = this.entryPrice - this.pipsFactor * this.item.Pip * this.stopPip;
            this.limitValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.limitPip;
        }
       



    }

    public get editLST():boolean
    {
        if(this.workspaceService.data.currentProvider == "OANDA" && !this.hideStop && !this.hideTrailingStop)
        {
            return true
        }
        else
        {
            return false
        }
    }


    private _hideStop: boolean = false;
    public get hideStop(): boolean {
        return this._hideStop;
    }
    public set hideStop(value: boolean) {
        this._hideStop = value;
    }


    private _hideTrailingStop: boolean = false;
    public get hideTrailingStop(): boolean {
        return this._hideTrailingStop;
    }
    public set hideTrailingStop(value: boolean) {
        this._hideTrailingStop = value;
    }


    private _lotStoClose: number = 0;
    public get lotStoClose (): number {
        return this._lotStoClose;
    }
    public set lotStoClose ( value: number ) {
        this._lotStoClose = value;

        this.quantity = this.initialQty - value;

    }


    private _initialQty: number = 0;
    public get initialQty (): number {
        return this._initialQty;
    }
    public set initialQty ( value: number ) {
        this._initialQty = value;
    }

    private _isPartialCloseWindow: boolean = false;
    public get isPartialCloseWindow (): boolean {
        return this._isPartialCloseWindow;
    }
    public set isPartialCloseWindow ( value: boolean ) {
        this._isPartialCloseWindow = value;
    }


    private _allowClose: boolean = true;
    public get allowClose (): boolean {
        return this._allowClose;
    }
    public set allowClose ( value: boolean ) {
        this._allowClose = value;
    }

    private _oldestOrder: string = "";
    public get oldestOrder (): string {
        return this._oldestOrder;
    }
    public set oldestOrder ( value: string ) {
        this._oldestOrder = value;
    }


    public partiallyCloseOrder(order: IOrdersData, latestTicket:string) {
        this.isPartialCloseWindow = true;

   
        if(latestTicket=="NOCHALLENGE")
        {
            this.allowClose = true;
        }
        else
        {
            if(order.Ticket !=latestTicket )
            {
             this.allowClose = false;
             this.oldestOrder = latestTicket;
            }
        }
       

        this.orderID = Number(order.Ticket);
        this.symbol = order.Symbol;

        this.operationType = order.Type.toLowerCase().includes("buy")
            ? OrderOperationType.Buy
            : OrderOperationType.Sell;

        this.quantity = order.Qty;
        this.initialQty = order.Qty;

        //console.log("dolotstoCloseList");
        this.dolotstoCloseList(this.quantity);
        this.lotStoClose = this.lotstoCloseList[0].value;
        //console.log(this.lotstoCloseList);


    }

    private lotsPositions = 10;
    public dolotstoCloseList(qty:number)
    {

    if(qty>this.lotsPositions)
    {

    
       let Step:number =  (qty - qty%this.lotsPositions)/this.lotsPositions;
       for(let i=1; i<this.lotsPositions; i++)
       {
           let v = Step*i;
           this.lotstoCloseList.push({
               label: this.kLabel(v),
               value: v
           })
       }
       this.lotstoCloseList.push({
        label: this.kLabel(qty),
        value: Number(qty)
    })
    }
    else
    {
        for(let i=1; i<qty; i++)
       {
        this.lotstoCloseList.push({
            label: this.kLabel(i),
            value: i
        })
       }
       this.lotstoCloseList.push({
        label: this.kLabel(qty),
        value: Number(qty) 
        });
    }



    }

    public kLabel(val:number)
    {
        let valStr = val.toString();
        if( valStr.substr(-3,3) == "000")
        {
            let length = valStr.length;
            return valStr.substring(0, length - 3) + "k";
        }

        return val.toString();
    }

   
    public get Kquantity (): string {
        return this.kLabel(this.quantity);
    }
   







    private _lotstoCloseList: ILotsClose[] = [];
    public get lotstoCloseList (): ILotsClose[] {
        return this._lotstoCloseList;
    }
    public set lotstoCloseList ( value: ILotsClose[] ) {
        this._lotstoCloseList = value;
    }

    public additionalPCFields:boolean = false;


    placeOrder(): void {
        this.placeOrderButton.nativeElement.onclick = null;
        if (!this.allowPlaceOrder) {
            return;
        }

        this.activeModal.close(this.entryData);
        this.prepareDataForTradeRequest();
    }

    protected _canShowPipValue: boolean = false;
    public get canShowPipValue(): boolean {
        if (this.item != undefined) {
            if (this.item.Type == SymbolTypeEnum.Forex || this.item.Type == SymbolTypeEnum.Index) {
                return true;
            }
        }

        return this._canShowPipValue;
    }
    public set canShowPipValue(value: boolean) {
        this._canShowPipValue = value;
    }

    updateOrder() {
        //  this.placeOrder();
        let update: EditRq = new EditRq();
        update.Type = this.typesEnum[this.type];
        update.Currency = this.symbol;
        update.Quantity = this.quantity;
        update.Side = this.operationTypesEnum[this.operationType];
        update.LimitPrice = this.limitch ? this.limitValue : 0;

        update.StopPrice = this.stopch ? this.stopValue : 0;

        update.LimitPips = this.limitPip;
        update.StopPips = this.stopPip;
        update.Id = String(this.orderID);

        if(this.trailingstopch)
        update.TrailingStopPips = this.trailingStopPip

        if(this.type==OrderEntryType.Pending && this.workspaceService.data.allowPendingOrders)
        {
            update.EnterPrice = this.entryPrice
        }


        //   //console.log(update)
        //   return;
        this.dataService.sendRequest({ Cmd: DataService.TYPE_EDITTRADE, Data: update });

        if(this.workspaceServiceService.data.mobileMode!="desktop")
        {
            this.workspaceServiceService.data.globaGridMode.mobileOrderButtonState.next(true);
        }


        this.activeModal.close(this.entryData);
    }


    partialCloseOrder()
    {
        let partialClose = new PartialCloseRq();
        partialClose.Ticket = this.orderID.toString();
        partialClose.CloseQty = this.lotStoClose;
        this.dataService.sendRequest({ Cmd: DataService.TYPE_PARTIACLOSE, Data: partialClose });

        if(this.workspaceServiceService.data.mobileMode!="desktop")
        {
            this.workspaceServiceService.data.globaGridMode.mobileOrderButtonState.next(true);
        }

        this.activeModal.close();
    }


    protected _currentRequestId: string = "";
    prepareDataForTradeRequest(): void {
        let trade: TradeRequestModel = new TradeRequestModel();

        trade.Type = this.typesEnum[this.type];
        trade.Currency = this.symbol;
        trade.Quantity = this.quantity;
        trade.Side = this.operationTypesEnum[this.operationType];
        trade.LimitPrice = this.limitValue;
        trade.StopPrice = this.stopValue;
        trade.LimitPips = this.limitPip;
        trade.StopPips = this.stopPip;

        if(this.trailingstopch)
        trade.TrailingStopPips = this.trailingStopPip;


       // if(this.AllowPendingOrders && this.type == OrderEntryType.Pending)
     //   {
             trade.EnterPrice = this.entryPrice;
     //  }
       



        trade.AccountId = this.selectedTradingAccountId;

        if (!this.stopch) {
            trade.StopPrice = 0;
        }

        if (!this.limitch) {
            trade.LimitPrice = 0;
        }

        if (!this.trailingstopch) {
            trade.TrailingStopPips = 0;
        }

        let lastTradeInformation:LastTradeData = {
                                                    qQty:this.qQty, 
                                                    qSize:this.qSize
                                                }


        if (this.cookieService.getCookie("IsLoggedIn") == "true") {
            ShowOrderConfirmationModal(
                this.modalService,
                trade,
                this.editedOrder == undefined ? undefined : this.editedOrder.Ticket,
                lastTradeInformation,
                this.workspaceService.data.mobileMode
            );
        } else {
            //ShowLoginModal(this.modalService);
     //       ShowLoginModal(this.modalService);
            this.cookieService.setCookie("orderLoginAction", "true", 1, "/");
            this.cookieService.setCookie("orderLoginActionTrade", JSON.stringify(trade), 1, "/");
        }
    }

    public get type(): OrderEntryType {
        return this._type;
    }
    public set type(v: OrderEntryType) {
        this.entryData.type = v;
        this._type = v;
        // this.getSymbolTypeLabel = this.getLabelByType(this.item.Type);
        if (this.type == this.typesEnum.Market) {
            this.rateDisabled = true;
            this.allowPlaceOrder = true;
        } else {
            this.rateDisabled = false;
            this.allowPlaceOrder = this.limitch || this.stopch || this.trailingstopch ? true : false;
        }


        if(this.AllowPendingOrders)
        {
            this.pipsFactor = -1;
        }

        else
        {
              this.pipsFactor = this.type == this.typesEnum.Pending ? 1 : -1;
        }
      




        this.updatePriceByOperationType();
    }

    protected _operationType: OrderOperationType = OrderOperationType.Buy;
    get operationType(): OrderOperationType {
        return this._operationType;
    }

    set operationType(v: OrderOperationType) {
        if (this.entryData) this.entryData.operationType = v;

        this._operationType = v;
        this.updatePriceByOperationType();
    }

    protected pipsFactor: number = -1;
    protected async updatePriceByOperationType() {
        if (!this.item) return;

        if (this._operationType == OrderOperationType.Buy) {
            if (this.item.Ask > -1) {
                if (this.type == this.typesEnum.Market) {
                    this.entryPrice = this.item.Ask;
                }

                if (!this.StopManualMode) {
                    this.stopValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.stopPip;
                }

                if (!this.LimitManualMode) {
                    this.limitValue = this.entryPrice - this.pipsFactor * this.item.Pip * this.limitPip;
                }
            }
        }

        if (this._operationType == OrderOperationType.Sell) {
            if (this.item.Bid > -1) {
                if (this.type == this.typesEnum.Market) {
                    this.entryPrice = this.item.Ask;
                }

                if (!this.StopManualMode) {
                    this.stopValue = this.entryPrice - this.pipsFactor * this.item.Pip * this.stopPip;
                }

                if (!this.LimitManualMode) {
                    this.limitValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.limitPip;
                }
            }
        }

        this.stopRev = Math.abs((this.entryPrice - this.stopValue) * this.quantity);
        this.limitRev = Math.abs((this.entryPrice - this.limitValue) * this.quantity);

        if (this.LimitManualMode == true) {
            this.updateLimitPips();
        }

        if (this.StopManualMode == true) {
            this.updateStopPips();
        }
      

      //  this.updateMarginRequiredAndPip();
    }

    protected async updateLimitPips() {
        let countOfPips = this.pipsFactor * Math.round((this.entryPrice - this._limitValue) / this.item.Pip);


        if (this.type == this.typesEnum.Market && this._operationType == OrderOperationType.Sell) {
            countOfPips = -1 * countOfPips;
        }

        if (this.type == this.typesEnum.Pending && this._operationType == OrderOperationType.Sell) {
            countOfPips = -1 * countOfPips;
        }



        
        this.limitPip = countOfPips;
    }

    protected async updateStopPips() {
        let countOfPips = this.pipsFactor * Math.round((this.entryPrice - this._stopValue) / this.item.Pip);
        if (this.type == this.typesEnum.Market && this._operationType == OrderOperationType.Buy) {
            countOfPips = -1 * countOfPips;
        }

        if (this.type == this.typesEnum.Pending && this._operationType == OrderOperationType.Buy) {
            countOfPips = -1 * countOfPips;
        }

        this.stopPip = countOfPips;
    }

    protected _symbol: string = "";
    protected precision: number = 3;
    protected _entryPrice: number = 0;
    protected _quantity: number = 1000;

    get symbol(): string {
        return this._symbol;
    }

    set symbol(v: string) {

       

        this._symbol = v;

        console.log("this.workspaceService.data.providerInstruments");
        console.log(this.workspaceService.data.providerInstruments);

        let m =  this.workspaceService.data.providerInstruments.find((l)=>l.Symbol== this._symbol);

        if(m)
        {
             this.oandaLeverage = m.MarginPercentage;
        }
       

        let item = this.workspaceService.data.boxes.filter(x => x.Symbol == v)[0]; // this.getSymbolItem(v);

        if (item !== undefined && item.Type !== undefined) {
            this.getSymbolTypeLabel = this.windowData[item.Type].SymbolTypeLabel;

            this.getRateLabel = this.windowData[item.Type].RateLabel;

            this.getMarginInfoLabel = this.windowData[item.Type].MarginInfoLabel;

            this.getSideLabel = this.windowData[item.Type].SideLabel;

            this.rawQtyShow = this.windowData[item.Type].rawQtyShow;

            //    this.equityQtyInputMode = this.windowData[item.Type].rawQtyShow;//item.Type != "equity"?false:this.equityQtyInputMode;

            this.qSizeListData = this.windowData[item.Type].qSizesList;

           




            this.qQtiesListData = this.windowData[item.Type].qQtiesList;
            this.showSideDropDown = this.windowData[item.Type].showSideDropDown;

            this.enableCurrencyFormatterForMargin = this.windowData[item.Type].currencyFormatter;

            if(this.quantity!=this.windowData[item.Type].defaultQty&&this.wasOpned )
            {
                this.quantity = this.qQty * this.qSize;
            }
            else
            {
                this.quantity = this.windowData[item.Type].defaultQty;
            }
            


            let lastTradeInformations = JSON.parse(this.workspaceService.
                data.lastTradeInformations);

            if(item.Type=="forex"&&lastTradeInformations!=null&&!this.wasOpned)
            {
                // this.equityQtyInputMode = true;
                this.qQty = lastTradeInformations.forex.qQty;

                if(lastTradeInformations.forex.qSize<1000)
                {
                    this.qSize = 1000;
                }
                else
                {
                     this.qSize = lastTradeInformations.forex.qSize;
                }
                this.wasOpned = true
            }

        }

        item.askSubject.subscribe((l: any) => {
            if (this.type == this.typesEnum.Market) {
                if (this.item.Symbol == this.symbol) {
                    this.updatePriceByOperationType();
                }
            }
        });

        this.entryData.symbol = v;
      
        this.precision = this.item.Decimal; //this.getPrecision( getPipBySymbol(v) );

        if (!this.rawQtyShow) {
            this.quantity = this.qQty * this.qSize;
        }

        if(v=="XAU/USD" || v=="XAG/USD")
        {
            let lastTradeInformations = JSON.parse(this.workspaceService.
                data.lastTradeInformations);

            this.qSizeListData = v=="XAU/USD"?this.defaultFixMetalsQSizeList:this.defaultFixMetalsAgQSizeList;

            if(lastTradeInformations!=null &&  lastTradeInformations.forex.qSize<1000)
            {
                 this.qSize =   lastTradeInformations.forex.qSize;

                if(v=="XAG/USD"&&lastTradeInformations.forex.qSize==1)
                {
                    this.qSize = 5;
                }

                if(v=="XAU/USD"&&lastTradeInformations.forex.qSize==5)
                {
                    this.qSize = 1;
                }
               
            }
            else
            {
                this.qSize = v=="XAU/USD"?1:100;
            }
            
        }
      

        if (this.type == this.typesEnum.Pending) {
            this.entryPrice = this.item.Ask;
        }


        this.updateMarginRequiredAndPip();
        this.updatePriceByOperationType();
        
    }


    private _wasOpned: boolean = false;
    public get wasOpned(): boolean {
        return this._wasOpned;
    }
    public set wasOpned(value: boolean) {
        this._wasOpned = value;
    }
    get entryPrice(): number {
        return this._entryPrice;
    }

    set entryPrice(v: number) {
        this.entryData.entryPrice = numberToFixedPrecision(Number(v), this.precision);
        this._entryPrice = numberToFixedPrecision(Number(v), this.precision);

        if (this.type == this.typesEnum.Pending) {
            this.updatePriceByOperationType();
        }
    }

    protected _entryLeadPrice: string = "";
    public get entryLeadPrice (): string {
        if(!this.entryPriceFieldFocused)
        {
            return this.entryPrice.toFixed(this.precision);
        }
        else
        {
            return this._entryLeadPrice;
        }
        
    }
    public set entryLeadPrice ( value: string ) {
        this._entryLeadPrice = value;
        this.entryPrice = Number(value);
    }

    protected _entryPriceFieldFocused: boolean = false;
    public get entryPriceFieldFocused (): boolean {
        return this._entryPriceFieldFocused;
    }
    public set entryPriceFieldFocused ( value: boolean ) {
        this.entryLeadPrice = this.entryPrice.toFixed(this.precision);
        this._entryPriceFieldFocused = value;
    }



    protected _equityQtyInputMode: boolean = false;
    public get equityQtyInputMode(): boolean {
        return this._equityQtyInputMode;
    }
    public set equityQtyInputMode(value: boolean) {
        this._equityQtyInputMode = value;
    }

    get quantity(): number {
        return this._quantity;
    }

    selectInput() {
        const inputElem = <HTMLInputElement>this.inputQty.nativeElement;
        inputElem.select();
    }

    set quantity(v: number) {
        if (v == -1) {
            this.selectInput();
            this.equityQtyInputMode = true;
            v = this.quantity;
        }

        /*
         if(!this.editMode && this.rawQtyShow == true  && this.equityQtyInputMode)
        {
            let s = this.qTiesList_equity.indexOf(Number(v));
            if(s>-1)
            {
               // this.equityQtyInputMode=false
            }
         //   v = this.qTiesList_equity.indexOf(Number(v))>=0?v:30; 

        }

        else{

            let mapqSize:number[] = this.qSizeListData.map(c=>{return c.value});

            let qtyTarget:number[] = crossMultiplyArrayValFinder(mapqSize,this.qQtiesList,Math.abs(v))
    
            if(!this.equityQtyInputMode && qtyTarget.length==0)
            {
              //  this.qSize = 10000;
             //   this.qQty = 1;
             //   this._quantity = v;
            }
        
        }
        */

        this.entryData.quantity = v;
        this._quantity = v;
        this.updateMarginRequiredAndPip();
        this.updatePriceByOperationType();
    }

    changePositionOverrider(e: any) {
        //console.log(e);
        if (e != -1) {
            this.equityQtyInputMode = false;
        }
    }

    operationTypeChange(operation: OrderOperationType) {
        this.operationType = operation;

        if (this.LimitManualMode == true) {
            this.updateLimitPips();
        }

        if (this.StopManualMode == true) {
            this.updateStopPips();
        }
    }

    protected _StopManualMode: boolean = false;
    set StopManualMode(v: boolean) {
        this._StopManualMode = v;
    }

    get StopManualMode() {
        return this._StopManualMode;
    }

    set stopValue(v: number) {
        this._stopValue = v;
    }

    get stopValue(): number {
       // let v = numberToFixedPrecision(this._stopValue, this.precision);;
        return Number(numberToFixedPrecision(this._stopValue, this.precision));
    }
    //

    protected _StopWithLeads:string = "";
    set StopWithLeads(v:string)
    {
        this._StopWithLeads = v;
    }

    get StopWithLeads():string
    {
        if(!this.stopFieldFocused)
        {
            return Number(this.stopValue).toFixed(this.precision);
        }
        else
        {
            return this._StopWithLeads;
        }
    }

    protected _LimitWithLeads:string = "";
    set LimitWithLeads(v:string)
    {
        this._LimitWithLeads = v;
    }

    get LimitWithLeads():string
    {
        if(!this.limitFieldFocused)
        {
            return Number(this.limitValue).toFixed(this.precision);
        }
        else
        {
            return this._LimitWithLeads;
        }
    }





    protected lastTimeOut: any = null;
    public updateStop(e: any) {
        clearTimeout(this.lastTimeOut);

        this.StopWithLeads = e.target.value;

        this.lastTimeOut = setTimeout(() => {
            this.stopValue = Number(e.target.value);
            let countOfPips = this.pipsFactor * Math.round((this._stopValue - this.entryPrice) / this.item.Pip);
            this.stopPip = countOfPips;
        }, 1000);
    }

    set stopPip(v: number) {
        this._stopPip = v;//numberToFixedPrecision(v, this.precision);
        //  this.StopManualMode = false;
        if (!this.StopManualMode) {
            this.updatePriceByOperationType();
        }
        if(this.stopch)
        {

            this.checkStopAndLimits()
    }
    }

    get stopPip(): number {
        return this._stopPip;
    }

    protected _LimitManualMode: boolean = false;
    set LimitManualMode(v: boolean) {
        this._LimitManualMode = v;
    }

    get LimitManualMode() {
        return this._LimitManualMode;
    }

    set limitValue(v: number) {
        this._limitValue = v;
    }

    get limitValue(): number {
        return Number(numberToFixedPrecision(this._limitValue, this.precision));
    }

    public updateLimit(e: any) {
        clearTimeout(this.lastTimeOut);

        this.LimitWithLeads = e.target.value;

        this.lastTimeOut = setTimeout(() => {
            this._limitValue = Number(e.target.value);

            let countOfPips = this.pipsFactor * Math.round((this.entryPrice - this._limitValue) / this.item.Pip);
            this.limitPip = countOfPips;
        }, 1000);
    }

    set limitPip(v: number) {
        this._limitPip = v;

        if (!this.LimitManualMode) {
            this.updatePriceByOperationType();
        }

        if(this.limitch)
        {

        
            this.checkStopAndLimits()
        }
    }

    get limitPip(): number {
        return this._limitPip;
    }

    public lostFocusUpdate() {
        // this.updatePriceByOperationType();
    }

    protected _stopRev: number = 0;

    set stopRev(v: number) {
        this._stopRev = numberToFixedPrecision(v, this.precision);
    }

    get stopRev(): number {
        return this._stopRev;
    }

    protected _limitRev: number = 0;

    set limitRev(v: number) {
        this._limitRev = numberToFixedPrecision(v, this.precision);
    }

    get limitRev(): number {
        return this._limitRev;
    }

    set rateDisabled(v: boolean) {
        this._rateDisabled = v;
    }

    get rateDisabled(): boolean {
        return this._rateDisabled;
    }

    protected _stopch: boolean = false;
    set stopch(v: boolean) {

        if(this.trailingstopch && v==true)
        {
            this.trailingstopch = false;
        }

        this._stopch = v;

        if (this.type == this.typesEnum.Pending) {
            if (this.stopch) {
                this.allowPlaceOrder = true;
            } else {
                this.allowPlaceOrder = this.limitch == true ? true : false;
            }
        } else {
            this.allowPlaceOrder = true;
        }

        this.checkStopAndLimits()

       
    
    }

    get stopch(): boolean {
        return this._stopch;
    }

    private _trailingstopch: boolean = false;
    public get trailingstopch(): boolean {
        return this._trailingstopch;
    }
    public set trailingstopch(value: boolean) {

        if(this.stopch && value==true)
        {
            this.stopch = false;
        }

        this._trailingstopch = value;
    }


    private _trailingStopPip: number = 5;
    public get trailingStopPip(): number {
        return this._trailingStopPip;
    }
    public set trailingStopPip(value: number) {
        this._trailingStopPip = value;
    }

    public isTrailingStop() {
        this.trailingstopch = !this.trailingstopch;
    }








    public isStop() {
        this.stopch = !this.stopch;

        if(this.stopch && this.stopValue==0)
        {
            this.stopValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.stopPip;
        //    this.limitValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.limitPip;
        }



    }

    protected _limitch: boolean = false;
    set limitch(v: boolean) {
        this._limitch = v;
        if (this.type == this.typesEnum.Pending) {
            if (this.limitch) {
                this.allowPlaceOrder = true;
            } else {
                this.allowPlaceOrder = this.stopch == true ? true : false;
            }
        } else {
            this.allowPlaceOrder = true;
        }

        this.checkStopAndLimits()
       
    }

    get limitch(): boolean {
        return this._limitch;
    }


    public checkStopAndLimits()
    {
        let allowstop = true;
        let allowlimit = true;
        if(this.limitch)
        {

        
        if(this.limitPip==0 || this.limitPip==null)
        {
            allowlimit = false;
        }
        else
        {
            allowlimit = true;
        }
        }

        
        if(this.stopch)
        {

        
        if(this.stopPip==0 || this.stopPip==null)
        {
            allowstop = false;
        }
        else
        {

            allowstop = true;
            
        }
    }
        this.allowPlaceOrder = (allowstop && allowlimit) ;
    }








    protected _allowPlaceOrder: boolean = true;
    set allowPlaceOrder(v: boolean) {
        this._allowPlaceOrder = v;
    }

    get allowPlaceOrder(): boolean {

        if(this.workspaceService.data.tournamentUserSelected)
        {

           this.symbols = this.onlyForexSymbols;
           this.activeSymbols = this.symbols
            if(this.workspaceService.data.availableAssetsForUser!.indexOf(this.item.Type)==-1)
            {
                return false;
            }
        }

        if(this.AllowPendingOrders)
        {

            if(this.type == OrderEntryType.Pending)
            {   
                if(this.operationType==OrderOperationType.Buy)
                {
                    return this.entryPrice>this.stopValue && this.entryPrice<this.limitValue
                }

                if(this.operationType==OrderOperationType.Sell)
                {
                    return this.entryPrice<this.stopValue && this.entryPrice>this.limitValue
                }
            }
            return this._allowPlaceOrder;
        }




        return this._allowPlaceOrder;
    }

    public isLimit() {
        this.limitch = !this.limitch;

        if(this.limitch && this.limitValue==0)
        {
          //  this.updatePriceByOperationType();
           // this.stopValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.stopPip;
            this.limitValue = this.entryPrice + this.pipsFactor * this.item.Pip * this.limitPip;
        }

    }

    getPrecision(n: number) {
        var s = n + "",
            d = s.indexOf(".") + 1;

        return !d ? 0 : s.length - d;
    }

    set marginRequired(v: number) {
        this._marginRequired = v;
    }

    get marginRequired() {
        return this._marginRequired;
    }

    set pipValue(v: number) {
        this._pipValue = v;
    }

    get pipValue() {
        return this._pipValue;
    }

    protected _qSize: number = 10000;
    public get qSize(): number {
        return this._qSize;
    }
    public set qSize(value: number) {

        if (!this.equityQtyInputMode) {
            this.quantity = this.qQty * value;
        }

        this._qSize = value;
    }

    protected _qQty: number = 1;
    public get qQty(): number {
        return this._qQty;
    }
    public set qQty(value: number) {
        if (!this.equityQtyInputMode) {
            this.quantity = this.qSize * value;
        }
        this._qQty = value;
    }

    public qTiesList_equity: number[] = [10, 30, 50];

    //public sideLabels:string[key:string]=[];

    protected _showSideDropDown: boolean = true;
    public get showSideDropDown(): boolean {
        return this._showSideDropDown;
    }
    public set showSideDropDown(value: boolean) {
        this._showSideDropDown = value;
    }

    protected _qSizeListData: IqSizeData[] = [];
    public get qSizeListData(): IqSizeData[] {
        return this._qSizeListData;
    }
    public set qSizeListData(value: IqSizeData[]) {
        this._qSizeListData = value;
    }

    protected _qQtiesListData: IqSizeData[] = [];
    public get qQtiesListData(): IqSizeData[] {
        return this._qQtiesListData;
    }
    public set qQtiesListData(value: IqSizeData[]) {
        this._qQtiesListData = value;
    }

    protected _getSymbolTypeLabel: string = "Currency";
    public get getSymbolTypeLabel(): string {
        return this._getSymbolTypeLabel;
    }
    public set getSymbolTypeLabel(value: string) {
        this._getSymbolTypeLabel = value;
    }

    protected _getRateLabel: string = "Rate";
    public get getRateLabel(): string {
        return this._getRateLabel;
    }
    public set getRateLabel(value: string) {
        this._getRateLabel = value;
    }

    protected _getMarginInfoLabel: string = "*Estimated Total";
    public get getMarginInfoLabel(): string {
        return this._getMarginInfoLabel;
    }
    public set getMarginInfoLabel(value: string) {
        this._getMarginInfoLabel = value;
    }

    protected _getSideLabel: string = "Side";
    public get getSideLabel(): string {
        return this._getSideLabel;
    }
    public set getSideLabel(value: string) {
        this._getSideLabel = value;
    }

    protected _enableCurrencyFormatterForMargin = false;
    public get enableCurrencyFormatterForMargin() {
        return this._enableCurrencyFormatterForMargin;
    }
    public set enableCurrencyFormatterForMargin(value) {
        this._enableCurrencyFormatterForMargin = value;
    }

    protected _stopFieldFocused: boolean = false;
    public get stopFieldFocused(): boolean {
        return this._stopFieldFocused;
    }
    public set stopFieldFocused(value: boolean) {
        this.StopWithLeads = this.stopValue.toFixed(this.precision);
        this._stopFieldFocused = value;
    }

    protected _limitFieldFocused: boolean = false;
    public get limitFieldFocused(): boolean {
        return this._limitFieldFocused;
    }
    public set limitFieldFocused(value: boolean) {
        this.LimitWithLeads =this.limitValue.toFixed(this.precision);
        this._limitFieldFocused = value;
    }

    public setqQty(e: number) {
        this.qQty = e;
    }


   // public selectedAccount

   public get accountsList():Account[]
   {
       return this.workspaceService.data.accounts;
   }

   public get activeAccountId()
   {
      return this.workspaceService.data.activeAccountId;
   }

    private _selectedTradingAccountId: number = 0;
    public get selectedTradingAccountId (): number {
        return this._selectedTradingAccountId;
    }
    public set selectedTradingAccountId ( value: number ) {
        this._selectedTradingAccountId = value;
    }


    public activeAccountTypeById(v:number): string | null | undefined
    {
       return this.workspaceService.data.accountTypeById(v);
    }

    public getFullAccountNameById(v:number)
    {

        return this.workspaceService.data.getFullAccountNameById(v);

    }

}


export interface IOrderEntryData {
    type: OrderEntryType;
    symbol: string;
    entryPrice: number;
    quantity: number;
    expires: boolean;
    expiryDate?: number;
    operationType: OrderOperationType;
}

export enum OrderEntryType {
    Market,
    Pending
    //  Stop,
    // StopLimit
}

export enum OrderOperationType {
    Sell,
    Buy
}

export function crossMultiplyArrayValFinder(qs: number[], qq: number[], val: number) {
    let qtyTarget: number[] = [];
    let a: number[] = qs;
    let b: number[] = qq;
    let t = a.map(function(x) {
        return b.map(function(y) {
            return y * x;
        });
    });
    let v: number = val; //this.quantity;

    t.forEach(function(value, i) {
        let found = value.indexOf(v);
        if (found > -1) {
            qtyTarget = [i, found];
            return;
        }
    });

    return qtyTarget;
}
export interface IDataBySymbolType {
    [key: string]: IOrderData;
}

export interface IOrderData {
    SideLabel: string;
    MarginInfoLabel: string;
    RateLabel: string;
    SymbolTypeLabel: string;
    showSideDropDown: boolean;
    currencyFormatter: boolean;
    rawQtyShow: boolean;
    defaultQty: number;
    qSizesList: IqSizeData[];
    qQtiesList: IqSizeData[];
}

export interface IqSizeData {
    label: string;
    value: number;
}

export interface LastTradeData
{
    qSize:number;
    qQty:number;
}

export interface lastTradeDataTyped {
    [index: string]: LastTradeData  | undefined;
}

export interface ILotsClose{
    label: string;
    value: number;
}